@if (isLoading) {
  <po-loading-overlay
    [p-text]="'Carregando '"
    [p-size]="'sm'"
  ></po-loading-overlay>
}

<app-toaster></app-toaster>

<po-page-default class="count-items-wrapper">
  <div
    class="po-row po-mb-2 po-mt-2 po-flex"
    style="justify-content: space-between; align-items: center"
  >
    <p
      class="po-font-title"
      style="font-size: 18px; font-weight: 600"
    >
      Contagem Finalização OP
    </p>
    <po-button
      p-label="Voltar"
      p-kind="secondary"
      (p-click)="goBack()"
    ></po-button>
  </div>

  <div class="po-page-wrapper">
    <div class="header-section">
      <div class="po-row">
        <div class="summary-row summary-header">
          <span>Contagem</span>
          <span>Quantidade</span>
          @if (countDetails.isSingleReading) {
            <span>Empresa / Ciclo / OP</span>
          }
        </div>
        <div class="summary-row summary-values">
          <span>{{ countDetails.code }}</span>
          <span>{{ countDetails.quantity }}</span>
          @if (countDetails.isSingleReading) {
            @if (
              countDetails.productionOrderBranchCode &&
              countDetails.productionOrderCycleCode &&
              countDetails.productionOrderCode
            ) {
              <span>
                {{
                  countDetails.productionOrderBranchCode +
                    ' / ' +
                    countDetails.productionOrderCycleCode +
                    ' / ' +
                    countDetails.productionOrderCode
                }}
              </span>
            } @else {
              <span>-</span>
            }
          }
        </div>
      </div>
    </div>

    <hr class="hr-divider" />

    @if (countDetails.isSingleReading) {
      <div class="po-row time-tracker-section po-mt-2 po-mb-2">
        <div class="po-sm-12 po-md-12 po-lg-12 po-flex-center">
          <po-button
            class="po-mr-1"
            [p-label]="timeStatus() === 'tracking' ? 'Em Andamento' : 'Iniciar'"
            [p-icon]="timeStatus() === 'tracking' ? 'an an-play-circle' : 'an an-play'"
            [p-kind]="timeStatus() === 'tracking' ? 'primary' : 'secondary'"
            (p-click)="startTimeTracking()"
            [p-disabled]="timeStatus() === 'tracking' || isLoading"
          ></po-button>

          <po-button
            class="po-ml-1"
            [p-label]="timeStatus() === 'paused' ? 'Pausado' : 'Pausar'"
            [p-icon]="timeStatus() === 'paused' ? 'an an-pause-circle' : 'an an-pause'"
            [p-kind]="timeStatus() === 'paused' ? 'danger' : 'secondary'"
            (p-click)="pauseTimeTracking()"
            [p-disabled]="timeStatus() === 'idle' || timeStatus() === 'paused' || isLoading"
          ></po-button>
        </div>

        @if (timeStatus() !== 'idle') {
          <div class="po-sm-12 po-text-center po-mt-1">
            <span
              class="po-font-text-bold"
              [style.color]="timeStatus() === 'paused' ? '#c44545' : '#2c7d3b'"
            >
              Status: {{ timeStatus() === 'paused' ? 'Tempo Pausado' : 'Cronômetro Ativo' }}
            </span>
          </div>
        }
      </div>
    }

    <po-input
      id="barcodeInput"
      #barcodeInput
      name="barcodeInput"
      class="po-xs-6"
      p-label="Barras:"
      [(ngModel)]="barCode"
      p-icon="an an-barcode"
      p-icon-click="onScan()"
      (keyup.enter)="onScan()"
      (keydown.tab)="onScan(); $event.preventDefault()"
      [p-disabled]="
        (countDetails.isSingleReading && (timeStatus() !== 'tracking' || isLoading))?.toString()
      "
      [p-help]="
        countDetails.isSingleReading && timeStatus() !== 'tracking'
          ? 'Inicie o registro de tempo para efetuar a leitura'
          : ''
      "
    ></po-input>

    <hr class="hr-divider" />

    <div class="po-row mobile-reverse">
      <div [class]="'po-sm-12 ' + (countDetails.isSingleReading ? 'po-md-8' : 'po-md-12')">
        <div class="scroll-area">
          @for (item of countDetails.items; track item.sequence) {
            <div class="po-row po-mb-2 po-align-items-center item-card">
              <div class="po-xs-10 po-sm-10 po-md-10 item-content">
                <div class="info-line">
                  <strong>Sequência:</strong>
                  {{ item.sequence }}
                </div>
                <div class="info-line">
                  <strong>Barra:</strong>
                  {{ item.barCode }}
                </div>
                <div class="info-line">
                  <strong>OP:</strong>
                  {{ item.productionOrderBranchCode }} - {{ item.productionOrderCycleCode }} -
                  {{ item.productionOrderCode }}
                </div>
                <div class="info-row">
                  <span class="half">
                    <strong>Prod:</strong>
                    {{ item.productCode }}
                  </span>
                  <span class="half">
                    <strong>Qt:</strong>
                    {{ item.quantity }}
                  </span>
                </div>
                <div class="info-line">
                  <strong>Desc:</strong>
                  {{ item.descriptionProduct }}
                </div>
              </div>
              <div class="po-xs-1 po-sm-1 po-md-1 po-text-right">
                <po-button
                  p-icon="an an-x-circle"
                  p-size="large"
                  p-kind="tertiary"
                  (p-click)="removeItem(item.sequence)"
                  class="icon-button"
                ></po-button>
              </div>
            </div>
          }
        </div>
      </div>
      @if (countDetails.isSingleReading) {
        <div class="po-sm-12 po-md-4">    
          <div class="po-pl-2 po-mt-1 mobile-no-padding">
          
            @if (!hasNoOperationalSequence()) {
              <div class="po-mb-2">
                <app-rhythm-gauge 
                  [description]="rhythmDescription()" 
                  [pointerRotation]="rhythmPointerRotation()"
                  [currentPercentage]="rhythmCurrentPercentage()">
                </app-rhythm-gauge>
              </div>
            }

            <app-custom-progress
              [title]="progressTitle"
              [infoText]="infoText()"
              [percentage]="value()"
              [footerText]="value() + '% concluído'"
            ></app-custom-progress>

            @if (!hasNoOperationalSequence()) {
              <app-custom-progress
                [title]="timeTitle"
                [infoText]="timeInfoText()"
                [percentage]="timeProgressPercent()"
                [dangerOnOverflow]="true"
                [footerText]="(timeProgressPercent() | number: '1.0-1') + '% do tempo previsto'"
              ></app-custom-progress>
            } @else {
              <div class="custom-progress-container">
                <div class="custom-progress-header">
                  <span class="custom-progress-title">{{ timeTitle }}</span>
                  <span class="custom-progress-info">{{ actualProductiveTime() | number: '1.2-2' }} / 00.00 min</span>
                </div>
                
                <div class="error-message-row">
                  Sequência Operacional não encontrada para o Local de Finalização
                </div>
              </div>
            }
          </div>
        </div>
      }
    </div>
    <hr class="hr-divider" />
   <div class="po-row po-mb-2 buttons-row" style="padding-bottom: 80px;">
      <po-button
        p-label="Finalizar OP"
        (p-click)="finalizeOp()"
        class="po-xs-7 po-sm-7 po-md-7 button-main"
        [p-disabled]="
          countDetails.quantity < 1 ||
          (countDetails.isSingleReading && timeStatus() === 'paused') ||
          isLoading
        "
      ></po-button>

       <po-button
        p-label="Finalizar + Nova Contagem"
        (p-click)="finalizeAndCreateNew()"
        class="po-xs-4 po-sm-4 po-md-4"
        [p-disabled]="
          countDetails.quantity < 1 ||
          (countDetails.isSingleReading && timeStatus() === 'paused') ||
          isLoading
        "
      ></po-button>

      <po-button
        p-size="small"
        class="po-xs-1 po-sm-1 po-md-1 button-main button-icon"
        p-kind="secondary"
        p-icon="an an-clipboard"
        (p-click)="openSummary()"
        [p-disabled]="isLoading"
      ></po-button>
    </div>
  </div>

  <po-modal
    #summaryModal
    p-title="Resumo da Finalização"
    [p-hide-close]="false"
  >
    <div class="po-row">
      <po-radio-group
        class="po-md-6 po-lg-6"
        name="viewMode"
        [(ngModel)]="viewMode"
        [p-options]="viewOptions"
      ></po-radio-group>
    </div>
    <hr />
    <div class="summary-scroll-area">
        @if (viewMode === 'op') {
          @for (resumo of resumoFinalizacaoPorOp; track resumo.orderKey) {
            <div class="po-row po-mb-2">
              <div class="po-xl-12 summary-op">
                <strong>OP:</strong>
                {{ resumo.orderKey }}
              </div>

              <div class="po-xl-12">
                <div class="summary-card">
                  <div class="summary-row summary-header" style="background-color: #f0f0f0">
                    <span>Total Contado</span>
                    <span>Total Pendente</span>
                    <span>Total Diferença</span>
                  </div>
                  <div class="summary-row summary-values" style="font-weight: bold">
                    <span>{{ resumo.totalContado }}</span>
                    <span>{{ resumo.totalPendente }}</span>
                    <span>{{ resumo.totalDiferenca }}</span>
                  </div>

                  <div class="po-mt-2">
                    <small><strong>Detalhamento por Produto:</strong></small>
                    @for (prod of resumo.produtos; track prod.productCode) {
                      <div style="display: flex; align-items: flex-start">
                        <div style="display: flex; flex: 1">
                          <strong>{{ prod.productCode }}</strong>
                          &nbsp;-&nbsp;{{ prod.description }}
                        </div>
                        <div style="display: flex; flex: 1; justify-content: space-around; margin-left: 1rem;">
                          <span>Cont: {{ prod.contado }}</span>
                          <span>Pend: {{ prod.pendente }}</span>
                          <span>Dif: {{ prod.diferenca }}</span>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          }
        } @else {
          @for (resumoProd of resumoFinalizacaoPorProduto; track resumoProd.productCode) {
            <div class="po-row po-mb-2">
              <div class="po-xl-12 summary-op">
                <strong>Produto:</strong>
                {{ resumoProd.productCode }} - {{ resumoProd.description }}
              </div>

              <div class="po-xl-12">
                <div class="summary-card">
                  <div class="summary-row summary-header" style="background-color: #f0f0f0">
                    <span>Total Contado</span>
                    <span>Total Pendente</span>
                    <span>Total Diferença</span>
                  </div>
                  <div class="summary-row summary-values" style="font-weight: bold">
                    <span>{{ resumoProd.totalContado }}</span>
                    <span>{{ resumoProd.totalPendente }}</span>
                    <span>{{ resumoProd.totalDiferenca }}</span>
                  </div>

                  <div class="po-mt-2">
                    <small><strong>Detalhamento por OP:</strong></small>
                    @for (op of resumoProd.ops; track op.orderKey) {
                      <div style="display: flex; align-items: flex-start">
                        <div style="display: flex; flex: 1">
                          <strong>{{ op.orderKey }}</strong>
                        </div>
                        <div style="display: flex; flex: 2; justify-content: space-around">
                          <span>Cont: {{ op.contado }}</span>
                          <span>Pend: {{ op.pendente }}</span>
                          <span>Dif: {{ op.diferenca }}</span>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          }
        }
    </div>
    <po-modal-footer></po-modal-footer>
  </po-modal>

  <po-modal
    #opQuestionModal
    p-title="Nova Ordem de Produção"
    [p-hide-close]="true"
  >
    <p>
      Ordem de Produção
      <b>{{ currentOpWarning() }}</b>
      relacionada ao produto lido diferente das lidas anteriormente. Deseja continuar?
    </p>
    <po-modal-footer>
      <button
        type="button"
        (click)="closeQuestionModal('ALWAYS')"
        class="po-text-button-custom"
      >
        Aceitar e não avisar mais
      </button>
      <po-button
        p-label="Não"
        (p-click)="closeQuestionModal('NO')"
      ></po-button>
      <po-button
        p-label="Sim"
        p-kind="primary"
        (p-click)="closeQuestionModal('YES')"
      ></po-button>
    </po-modal-footer>
  </po-modal>

  <po-modal
    #pauseReasonModal
    p-title="Motivo da Pausa"
    [p-hide-close]="true"
    [p-primary-action]="{
      label: 'Confirmar Pausa',
      action: confirmPause.bind(this),
      disabled: selectedPauseReason === null,
      danger: true,
    }"
    [p-secondary-action]="{
      label: 'Cancelar',
      action: closePauseModal.bind(this),
    }"
  >
    <div class="po-row">
      @if (isPauseModalVisible()) {
        <po-select
          class="po-md-12"
          name="pauseReason"
          p-label="Selecione o motivo da pausa:"
          p-placeholder="Selecione um motivo..."
          p-required
          [p-options]="pauseReasonsOptions"
          [ngModel]="selectedPauseReason"
          (ngModelChange)="onPauseReasonChange($event)"
        ></po-select>
      }
    </div>
  </po-modal>
</po-page-default>
